export const HELP_SET_SEARCH = 'HELP_SET_SEARCH';

export const helpSetSearch = value => {
    return {
        type: HELP_SET_SEARCH,
        value
    };
};



// WEBPACK FOOTER //
// ./src/store/help/actions.js